import { Redirect, useLocalSearchParams } from 'expo-router';

export default function LegacyAuthRoute() {
  const params = useLocalSearchParams<{ mode?: string }>();

  return <Redirect href={{ pathname: '/sign-in', params }} />;
}
